import { Box, Tooltip, Typography, TypographyProps } from "@mui/material"
import { ConventionIcon } from 'shared/icons'

import { KojinResult } from "interface/kojin"
import { flatJoin } from "shared/util"

type ConventionChipsProps = {
	convention: KojinResult["convention"]
} & TypographyProps
export const ConventionChips = ({
	convention,
	...others
}: ConventionChipsProps) => convention && convention.length > 0 ? (
	<Tooltip title={
		<Box>
			{convention.map((cnv, i) => (
				<Typography
					{...others}
					key={`convention-${i}`}
				>{
					flatJoin(' ', cnv.numberOfTimes, cnv.conventionName)
				}</Typography>
			))}
		</Box>
	}>
		<ConventionIcon color='secondary' />
	</Tooltip>
) : <></>